module.exports = __webpack_public_path__ + "img/34.aeb0dd9c.png";